import { IAppState } from "../../../app/appTypes"
import { ICaseClassification } from "../../../features/caseClassification/state/caseClassificationTypes"

export const getAllCaseClassifications = (state: IAppState): { [id: string]: ICaseClassification } => state.entities.caseClassification.byId

export const getAllCaseClassificationIds = (state: IAppState): string[] => state.entities.caseClassification.allIds

export const getCaseClassificationById = (state: IAppState, id: string): ICaseClassification =>  state.entities.caseClassification.byId[id]
